import { render, staticRenderFns } from "./ImagemapMessage.vue?vue&type=template&id=ef13abc6&scoped=true&"
import script from "./ImagemapMessage.vue?vue&type=script&lang=js&"
export * from "./ImagemapMessage.vue?vue&type=script&lang=js&"
import style0 from "./ImagemapMessage.vue?vue&type=style&index=0&id=ef13abc6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef13abc6",
  null
  
)

export default component.exports